var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"background":"#84dec0","point":"#1da8ce","tooltip":"new user","points":_vm.points}})}
var staticRenderFns = []

export { render, staticRenderFns }